import { httpInterceptor } from '../http-interceptor';

export class CarrierService {
  static ENDPOINTS = {
    GET_ALL: 'Carrier/getall',
    SAVE_CARRIER: 'Carrier/savecarrier',
    GET_BY_ID: 'Carrier/getbyid',
  };

  static async getAllCarriers() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async saveCarrier(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_CARRIER, data);
  }

  static async getCarrierById(carrierId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${carrierId}`);
  }
}

